import React from "react";

export default function ArrowLeftIcon({ id, style }) {
    return <svg id={id} width="24" height="25" viewBox="0 0 14 25" fill="none" xmlns="http://www.w3.org/2000/svg" style={{stroke: "#FB6503", ...style}}>
        <path d="M9.57 6.42993L3.5 12.4999L9.57 18.5699" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    </svg>;
}


// WEBPACK FOOTER //
// ./src/rifa/components/layout/icons/arrowLeftIcon.jsx